/* globals $ */
var rondheight = $(window).height()
var rondwidth = ($(window).width()) / 100 * 35
var rondtop = rondheight / 2 - rondwidth / 2
$('.about-rond ').css('top', rondtop + 'px')
$('#texte-experience').css('margin-top', rondtop + 'px')
$('.rond').css('height', rondwidth + 'px')

$('#contact-us').click(function () {
  $('#contact').css('display', 'block')
})
// $('#about-us').click(function(){
// $(document).scrollTop(0);
// $('#about').fadeIn();
//  });
$('#contact').click(function () {
  $(this).css('display', 'none')
})
$('#aboutclose').click(function () {
  $('#about').css('display', 'none')
})

$('#about').click(function () {
  var st = $(window).scrollTop()
  $('html, body').animate({
    scrollTop: st + 250
  }, {
    duration: 1000
  })
})

$('#about-us').click(function () {
  $('#about').fadeIn('fast')
    // lock scroll position, but retain settings for later
    // $('#main-wrapper').css('overflow','hidden');
  $('html, body').animate({
    scrollTop: 0
  }, {
    duration: 500
  })
})
